import { render, staticRenderFns } from "./CouriersStatistics.vue?vue&type=template&id=12493d79"
import script from "./CouriersStatistics.vue?vue&type=script&lang=ts"
export * from "./CouriersStatistics.vue?vue&type=script&lang=ts"
import style0 from "./CouriersStatistics.vue?vue&type=style&index=0&id=12493d79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports